import { Model, RailsFormat } from "./model"
import { Utilities } from "@helpers/utilities"
import * as moment from "moment"
import { TwoWeekBlock } from "./two-week-block";
import { TermExtraDay } from "./term-extra-day";

export class Term extends Model {

  constructor(
    public id?: number,
    public name: string = "",
    public startDate: Date = null,
    public endDate: Date = null,
    public isHoliday: boolean = false,
    public isOnlineEnrolmentEnabled: boolean = false,
    public number: number = 0,
    public isCurrentTerm: boolean = false,
    public twoWeekBlocks: TwoWeekBlock[] = [],
    public updatedAt: Date = null,
    public createdAt: Date = null,
    public extraDays: TermExtraDay[] = [],
  ) { super() }

  static clone(obj: any) {
    const term = new this()

    if (obj.id) { term.id = obj.id }
    if (obj.name) { term.name = obj.name }
    if (obj.startDate) { term.startDate = Utilities.makeDate(obj.startDate) }
    if (obj.endDate) { term.endDate = Utilities.makeDate(obj.endDate) }
    if (obj.isHoliday) { term.isHoliday = obj.isHoliday }
    if (obj.isOnlineEnrolmentEnabled) { term.isOnlineEnrolmentEnabled = obj.isOnlineEnrolmentEnabled }
    if (obj.isCurrentTerm) { term.isCurrentTerm = obj.isCurrentTerm }
    if (obj.number) { term.number = obj.number }
    if (obj.createdAt) { term.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { term.updatedAt = new Date(obj.updatedAt) }

    if (obj.twoWeekBlocks && obj.twoWeekBlocks.length > 0) {
      term.twoWeekBlocks = obj.twoWeekBlocks.map((wb: any) => { 
        return TwoWeekBlock.clone(wb) })
    }

    if (obj.extraDays && obj.extraDays.length > 0) {
      term.extraDays = obj.extraDays.map((ted: any) => {
        return TermExtraDay.clone(ted) })
    }

    return term
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }
    if (this.startDate) {
      response.startDate = moment(this.startDate).format("YYYY-MM-DD")
    }
    if (this.endDate) {
      response.endDate = moment(this.endDate).format("YYYY-MM-DD")
    }

    this.twoWeekBlocks = null
    this.extraDays = null

    return response
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/term.ts